import { useCallback, useContext, useEffect, useMemo, useReducer, useRef, useState } from "react";
import { useDispatch } from "react-redux";
// import axios from "axios";

import usePageAttachmentTabs from "../Hooks/usePageAttachmentTabs";
import WitnessesMain from "../Components/Witnesses/WitnessesMain";
import Sidebar from "../Components/Sidebars/main";
import NavBar from "../Components/Navbars/main";
import ActionBarComponent from "../Components/common/ActionBarComponent";
// import TabsClient from "../Components/new-client-dashboard/Tabs";
import NotesSectionDashboard from "../Components/NotesSectionDashboard/main";
import {
  fetchPageObject,
  fetchShakespeareStatus,
  getCaseId,
  getClientId,
  // getToken,
} from "../Utils/helper";
import { ClientDataContext } from "../Components/ClientDashboard/shared/DataContext";
import { fetchCreateInsuranceModalData } from "../Redux/insurance/insuranceSlice";
import Footer from "../Components/common/footer";
import PhotoTab from "../Components/new-client-dashboard/tabs/photo-tab/photo";
import PageDocsTab from "../Components/DocPage/new-tab/page-docs-tab";
import AddWitnessModal from "../Components/Witnesses/modals/AddWitnessModal";
import ConfirmDeletePopup from "../Components/DefendantPage/DefandantMain/ConfirmDeletePopup";
import useIsStates from "../Hooks/getStates";
import WitnessSummaryTable from "../Components/Witnesses/Witnesses/WitnessSummaryTable";
import DatesIcon from "../assets/images/dates.svg";
import DetailIcon from "../assets/images/detail.svg";
import SimpleIcon from "../assets/images/simple-icon.svg";
// import TreatmentTabs from "../Components/TreatmentPage/TreatmentTabs";
import WitnessSimpleView from "../Components/Witnesses/Witnesses/WitnessSimpleView";
// import NewChangesTabs from "../Components/new-client-dashboard/NewChangesTabs";
import addIconGold from "../assets/Add-icon-gold.svg";
import SmartResponsiveTabsContainer from "../Components/DefendantPage/DefandantMain/components/ResponsiveTabDefendants";
import PlaceHolderifNothingAdded from "../Components/components-new-final/placeholder-nothing-added";
import { api_without_cancellation } from "../api/api";

const PageContent = ({
  currentPage,
  witnessesRefs,
  setReducer,
  reducerValue,
  witnessData,
  retainedByList,
  viewType,
  onEditWitness,
}) => {
  // Filter witnesses based on current page
  const getFilteredWitnesses = () => {
    if (currentPage === "all") {
      return witnessData?.witnesses;
    }

    if (currentPage.startsWith("client_")) {
      const clientId = parseInt(currentPage.replace("client_", ""));
      return witnessData?.witnesses?.filter(
        (witness) =>
          witness?.witness_for_entity === "Client" && witness?.witness_for_record_id === clientId
      );
    }

    if (currentPage.startsWith("defendant_")) {
      const defendantId = parseInt(currentPage.replace("defendant_", ""));
      return witnessData?.witnesses?.filter(
        (witness) =>
          witness?.witness_for_entity === "Defendant" &&
          witness?.witness_for_record_id === defendantId
      );
    }

    if (currentPage.startsWith("other_")) {
      const otherId = parseInt(currentPage.replace("other_", ""));
      return witnessData?.witnesses?.filter(
        (witness) =>
          witness?.witness_for_entity === "Other" && witness?.witness_for_record_id === otherId
      );
    }

    return witnessData?.witnesses;
  };

  const filteredWitnesses = getFilteredWitnesses();

  switch (currentPage) {
    case "photo":
      return <PhotoTab pageId={10} pageName={"Witness"} />;
    default:
      // Check if we should show summary or detailed view
      if (viewType === "summary") {
        return (
          <WitnessSummaryTable witnesses={filteredWitnesses || []} onEditWitness={onEditWitness} />
        );
      } else if (viewType === "simple") {
        return (
          <WitnessSimpleView
            setReducer={setReducer}
            reducerValue={reducerValue}
            witnesses={filteredWitnesses || []}
            retainedByList={retainedByList}
            onEditWitness={onEditWitness}
          />
        );
      } else {
        // Detailed view (default)
        return (
          <>
            {filteredWitnesses?.map((object) => (
              <div key={object?.id} ref={(el) => (witnessesRefs.current[object?.id] = el)}>
                <WitnessesMain
                  setReducer={setReducer}
                  reducerValue={reducerValue}
                  object={object}
                  witnesses={witnessData?.witnesses}
                  retainedByList={retainedByList}
                  onEditWitness={onEditWitness}
                />
              </div>
            ))}
          </>
        );
      }
  }
};

function WitnessesPage() {
  const [currentPage, setCurrentPage] = useState("all");
  const handlePageChange = useCallback((pageType) => {
    setCurrentPage(pageType);
  }, []);
  // const accessToken = getToken();
  const origin = process.env.REACT_APP_BACKEND_URL || "https://dev.simplefirm.com";

  const { isClientDataUpdated } = useContext(ClientDataContext);

  const [isDummy, setIsDummy] = useState(true);
  const [witnessData, setWitnessData] = useState(null);
  const [_witnessDataArr, setWitnessDataArr] = useState([]);
  const [retainedByList, setRetainedByList] = useState({
    clients: [],
    defendants: [],
    otherParties: [],
  });
  const dispatch = useDispatch();
  const clientId = getClientId();
  const caseId = getCaseId();
  const [reducerValue, setReducer] = useReducer((x) => x + 1, 0);
  // const modalData = useSelector((state) => state.insurances.modalData);
  const witnessesRefs = useRef({});
  const [viewType, setViewType] = useState("summary");
  const isMediaPage = currentPage === "photo" || currentPage === "docs";
  const activeViewType = isMediaPage ? null : viewType;
  const [showAddWitnessModal, setShowAddWitnessModal] = useState(false);
  const [editTarget, setEditTarget] = useState(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const states = useIsStates();
  const [pageObject, setPageObject] = useState(null);

  useEffect(() => {
    if (caseId && !pageObject) {
      fetchPageObject(caseId, 10).then((data) => {
        setPageObject(data);
      });
    }
  }, [caseId, pageObject]);

  const fetchData = async () => {
    try {
      const [dummyStatusResponse, retainedByListResponse, witnessesResponse] = await Promise.all([
        api_without_cancellation.get("/api/general/panel_page_block/", {
          params: {
            case_id: caseId,
            page_id: 10,
          },
        }),

        api_without_cancellation.get(`/api/experts_retained_by_list/${clientId}/${caseId}/`),
        api_without_cancellation.get(`/api/witnesses/${clientId}/${caseId}/`),
        // api_without_cancellation.get(`/api/experts_retained_by_list/${clientId}/${caseId}/`, {
        //   headers: {
        //     "Content-Type": "application/json",
        //     Authorization: accessToken,
        //   },
        // }),
        // api_without_cancellation.get(`/api/witnesses/${clientId}/${caseId}/`, {
        //   headers: {
        //     "Content-Type": "application/json",
        //     Authorization: accessToken,
        //   },
        // }),
      ]);

      setIsDummy(dummyStatusResponse?.data?.status);
      setRetainedByList({
        clients: retainedByListResponse.data.client,
        defendants: retainedByListResponse.data.defendants,
        otherParties: retainedByListResponse.data.other_parties,
      });
      setWitnessData(witnessesResponse.data);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    fetchData();
    // sending page ids directly now.
    fetchShakespeareStatus(caseId, 10, dispatch);
  }, [origin, isClientDataUpdated, reducerValue, dispatch]);

  useEffect(() => {
    if (isDummy && witnessData) {
      const blockedWitnesses = witnessData?.witnesses?.filter((witness) => witness?.is_blocked);
      const lastBlockedWitness = blockedWitnesses?.length
        ? blockedWitnesses[blockedWitnesses.length - 1]
        : null;
      setWitnessDataArr([lastBlockedWitness]);
    } else {
      setWitnessDataArr(witnessData?.witnesses);
    }

    dispatch(
      fetchCreateInsuranceModalData({
        client_id: clientId,
        case_id: caseId,
      })
    );
    fetchShakespeareStatus(caseId, 10, dispatch);
  }, [witnessData, isDummy, dispatch, clientId, caseId]);

  const handleEditWitness = useCallback((w) => {
    setEditTarget(w);
    setShowAddWitnessModal(true);
  }, []);

  const handleClose = () => {
    setShowAddWitnessModal(false);
    setEditTarget(null);
  };

  const handleDeleteSubmission = async () => {
    try {
      const response = await api_without_cancellation.delete(
        `api/witnesses/delete_witness/${editTarget?.id}/`
      );
      await api_without_cancellation.delete("/api/general/panel_page_block", {
        params: { page_id: 10, case_id: caseId },
      });
      if (response.status === 204) {
        setShowDeleteConfirm(false);
        setShowAddWitnessModal(false);
        setEditTarget(null);
        await fetchData();
      }
    } catch (error) {
      console.error("Error deleting witness:", error);
    }
  };

  const hasWitnessesForEntity = (entityType, entityId) => {
    return witnessData?.witnesses?.some(
      (witness) =>
        witness?.witness_for_entity === entityType && witness?.witness_for_record_id === entityId
    );
  };

  const [hasAnyWitnesses, setHasAnyWitnesses] = useState(0);

  useEffect(() => {
    setHasAnyWitnesses(witnessData?.witnesses?.length);
  }, [witnessData]);

  const mainTabs = useMemo(() => {
    const tabs = [];
    tabs.push({
      id: "all",
      label: "All",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-5)",
      activeColor: "white",
      onClick: () => handlePageChange("all"),
      leftHand: false,
    });
    // Only add "All" tab if witnesses exist

    // Add client witness tabs only if witnesses exist for that client
    retainedByList.clients?.forEach((client) => {
      if (hasWitnessesForEntity("Client", client.id)) {
        const lastName = client?.last_name || "";
        const firstName = client?.first_name || "";
        const midInitial = client?.middle_name
          ? `${client.middle_name.charAt(0).toUpperCase()}.`
          : "";
        const label =
          lastName && firstName
            ? `${lastName}, ${firstName} ${midInitial}`
            : lastName
              ? `${lastName} ${midInitial}`
              : `${firstName}`;
        tabs.push({
          id: `client_${client.id}`,
          label: (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                gap: "5px",
              }}
            >
              <i className="ic ic-15 ic-client d-flex align-items-center justify-content-center" />
              {label} Witnesses
            </div>
          ),
          className: "tab-trapezium-cycles-corners",
          background: "var(--primary-5)",
          activeColor: "white",
          onClick: () => handlePageChange(`client_${client.id}`),
          leftHand: false,
        });
      }
    });

    // Add defendant witness tabs only if witnesses exist for that defendant
    retainedByList.defendants?.forEach((defendant) => {
      if (hasWitnessesForEntity("Defendant", defendant.id)) {
        let label = "";
        if (defendant?.defendant_type_id === 1) {
          // Private individual - "Last Name, First Name"
          const lastName = defendant?.last_name || "";
          const firstName = defendant?.first_name || "";
          const midInitial = defendant?.middle_name
            ? `${defendant.middle_name.charAt(0).toUpperCase()}.`
            : "";
          label =
            lastName && firstName
              ? `${lastName}, ${firstName} ${midInitial}`
              : lastName
                ? `${lastName} ${midInitial}`
                : `${firstName}`;
        } else if (defendant?.defendant_type_id === 2) {
          // Commercial (2) or Public (3) entity - use entity name
          label = `${defendant?.entity_name || "Entity"}`;
        } else {
          label = `${defendant?.entity_name || "Entity"}`;
        }

        tabs.push({
          id: `defendant_${defendant.id}`,
          label: (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                gap: "5px",
              }}
            >
              <i className="ic ic-15 ic-defendants d-flex align-items-center justify-content-center" />
              {label} Witnesses
            </div>
            // <>
            //   <i className="ic ic-15 ic-defendants m-r-5" />
            //   {label} Witnesses
            // </>
          ),
          className: "tab-trapezium-cycles-corners",
          background: "var(--primary-5)",
          activeColor: "white",
          onClick: () => handlePageChange(`defendant_${defendant.id}`),
          leftHand: false,
        });
      }
    });

    // Add other party witness tabs only if witnesses exist for that party
    retainedByList.otherParties?.forEach((party) => {
      if (hasWitnessesForEntity("Other", party.id)) {
        const midInitial = party?.party_middle_name
          ? `${party.party_middle_name.charAt(0).toUpperCase()}.`
          : "";
        const name =
          party.entity_name ||
          `${party.party_first_name + "," || ""} ${party.party_last_name || ""} ${midInitial}`.trim();
        tabs.push({
          id: `other_${party.id}`,
          label: (
            <div
              className="d-flex align-items-center justify-content-center"
              style={{
                gap: "5px",
              }}
            >
              <i className="ic ic-15 ic-client d-flex align-items-center justify-content-center" />
              {name} Witnesses
            </div>
            // <>

            //   <i className="ic ic-19 ic-client m-r-5" />
            //   {name} Witnesses
            // </>
          ),
          className: "tab-trapezium-cycles-corners",
          background: "var(--primary-5)",
          activeColor: "white",
          onClick: () => handlePageChange(`other_${party.id}`),
          leftHand: false,
        });
      }
    });

    return tabs;
  }, [handlePageChange, retainedByList, witnessData, hasAnyWitnesses]);

  const viewTabs = useMemo(() => {
    const tabs = [];

    tabs.push(
      {
        id: "summary",
        label: "Summary",
        className:
          activeViewType === "summary"
            ? "active tab-trapezium-cycles-corners"
            : "tab-trapezium-cycles-corners",
        background:
          activeViewType === "summary" ? "var(--primary) !important" : "var(--primary-60)",
        activeColor: "white",
        onClick: () => {
          currentPage === "photo" && handlePageChange("all");
          setViewType("summary");
          handlePageChange("all");
        },
        leftHand: true,
        span: (
          <span
            style={{
              width: "15px",
              height: "15px",
            }}
            className="fw-bold d-flex align-items-center justify-content-center  text-gold"
          >
            <img
              src={DatesIcon}
              style={{
                width: "15px",
                height: "15px",
              }}
              alt="Detail"
            />
          </span>
        ),
      },
      {
        id: "simple",
        label: "Simple",
        className:
          activeViewType === "simple"
            ? "active tab-trapezium-cycles-corners"
            : "tab-trapezium-cycles-corners",
        background: activeViewType === "simple" ? "var(--primary) !important" : "var(--primary-60)",
        activeColor: "white",
        onClick: () => {
          isMediaPage && handlePageChange("all");
          setViewType("simple");
        },
        leftHand: true,
        span: (
          <span
            style={{
              width: "15px",
              height: "15px",
            }}
            className="fw-bold d-flex align-items-center justify-content-center  text-gold"
          >
            <img
              src={SimpleIcon}
              style={{
                width: "15px",
                height: "15px",
              }}
              alt="Detail"
            />
          </span>
        ),
      },

      {
        id: "detailed",
        label: "Detailed",
        className:
          activeViewType === "detailed"
            ? "active tab-trapezium-cycles-corners"
            : "tab-trapezium-cycles-corners",
        background:
          activeViewType === "detailed" ? "var(--primary) !important" : "var(--primary-60)",
        activeColor: "white",
        onClick: () => {
          isMediaPage && handlePageChange("all");
          setViewType("detailed");
        },
        leftHand: true,
        span: (
          <span
            style={{
              width: "15px",
              height: "15px",
            }}
            className="fw-bold d-flex align-items-center justify-content-center  text-gold"
          >
            <img
              src={DetailIcon}
              style={{
                width: "15px",
                height: "15px",
              }}
              alt="Detail"
            />
          </span>
        ),
      }
    );

    return tabs;
  }, [witnessData, hasAnyWitnesses, activeViewType, currentPage, isMediaPage]);

  const buttonTabs = useMemo(() => {
    const tabs = [];

    tabs.push({
      id: "witness-add",
      label: "Witness",
      className: "tab-trapezium-cycles-corners",
      background: "var(--primary-60)",
      left: "0px",
      onClick: () => setShowAddWitnessModal(true),
      leftHand: true,
      span: (
        <span className="fw-bold ic-15 d-flex align-items-center">
          <img className="d-flex align-items-center justify-content-center" src={addIconGold} />
        </span>
      ),
    });

    return tabs;
  }, []);

  const photoTabs = useMemo(
    () => [
      {
        id: "docs",
        label: "Docs",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-60)",
        activeColor: "white",
        left: "0px",
        onClick: () => handlePageChange("docs"),
        leftHand: true,
        span: (
          <span className="fw-bold ic-15 d-flex align-items-center">
            <img
              src="https://simplefirm-bucket.s3.amazonaws.com/static/images/documents-icon-color_b6TvcB7.svg"
              width={15}
              height={15}
              alt=""
            />
          </span>
        ),
      },
      {
        id: "photo",
        label: "Photos",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-60)",
        activeColor: "white",
        left: "0px",
        onClick: () => handlePageChange("photo"),
        leftHand: true,
        span: (
          <span
            style={{
              width: "15px",
              height: "15px",
            }}
            className="fw-bold d-flex align-items-center justify-content-center text-gold"
          >
            <img
              src={
                "https://simplefirm-bucket.s3.amazonaws.com/static/images/photo-icon-color_2CyRX1a_GgdCtlG.svg"
              }
              style={{
                width: "15px",
                height: "15px",
              }}
              alt="Detail"
            />
          </span>
        ),
      },
    ],
    []
  );
  const attachmentTabs = usePageAttachmentTabs(10, photoTabs);

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);
  const adjustReportColumnWidths = () => {
    const pinColumn = (selector) => {
      const cols = document.querySelectorAll(selector);
      if (!cols.length) return;
      let maxWidth = 0;
      cols.forEach((col) => {
        maxWidth = Math.max(maxWidth, col.getBoundingClientRect().width);
      });
      cols.forEach((col) => {
        col.style.width = `${maxWidth}px`;
        col.style.minWidth = `${maxWidth}px`;
      });
    };

    pinColumn(".witness-col-1");
    pinColumn(".witness-col-2");
    pinColumn(".witness-col-3");
    pinColumn(".witness-col-4");
  };

  useEffect(() => {
    adjustReportColumnWidths();
    window.addEventListener("resize", adjustReportColumnWidths);
    return () => window.removeEventListener("resize", adjustReportColumnWidths);
  }, [witnessData?.witnesses, currentPage]);
  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container overflow-hidden">
          <NavBar flaggedPageName="10" />
          <ActionBarComponent
            src={pageObject?.page_icon}
            page_name={pageObject?.name}
            pageObj={pageObject}
            isChecklist={pageObject?.PageChklst || false}
          />
          <div className="TreatmentPage-main-container invisible-scrollbar">
            <SmartResponsiveTabsContainer
              isEmpty={isDummy || witnessData?.witnesses?.length === 0}
              HandlePage={currentPage}
              tabsData={mainTabs}
              viewTab={viewTabs}
              viewTabControlled={true}
              addTab={buttonTabs}
              photoTab={attachmentTabs}
              photoTabControlled={true}
              handlePageChange={handlePageChange}
              viewType={activeViewType}
            />
            {/* <PageTitle currentPage={currentPage} retainedByList={retainedByList} /> */}
            {witnessData?.witnesses?.length === 0 && !isDummy && !isMediaPage && (
              <>
                <PlaceHolderifNothingAdded
                  text1={"No Witnesses Added on Case"}
                  text2={"Click to Add"}
                  pageIcon={pageObject?.page_icon}
                  onClick={() => {
                    setShowAddWitnessModal(true);
                  }}
                />
              </>
            )}
            {witnessData?.witnesses?.length === 0 && isDummy && !isMediaPage && (
              <>
                <PlaceHolderifNothingAdded
                  text1={"No Witness on the Case"}
                  text2={"Page is Marked Complete"}
                  text3={"To Add a Witness to the Case Click Here"}
                  pageIcon={pageObject?.page_icon}
                  completed
                  onClick={() => {
                    setShowAddWitnessModal(true);
                  }}
                />
              </>
            )}
            {witnessData?.witnesses?.length > 0 && !isDummy && !isMediaPage && (
              <PageContent
                currentPage={currentPage}
                witnessesRefs={witnessesRefs}
                setReducer={setReducer}
                reducerValue={reducerValue}
                witnessData={witnessData}
                retainedByList={retainedByList}
                viewType={viewType}
                onEditWitness={handleEditWitness}
              />
            )}

            {currentPage === "docs" && (
              <PageDocsTab
                key={`${clientId}-${caseId}`}
                pageId={10}
                pageName={pageObject?.name}
                pageIcon={pageObject?.page_icon}
              />
            )}

            {currentPage === "photo" && (
              <PageContent
                currentPage={currentPage}
                witnessesRefs={witnessesRefs}
                setReducer={setReducer}
                reducerValue={reducerValue}
                witnessData={witnessData}
                retainedByList={retainedByList}
                viewType={viewType}
                onEditWitness={handleEditWitness}
              />
            )}

            <NotesSectionDashboard pageName={"Witness"} />
          </div>
        </div>
      </div>
      <Footer />
      {showAddWitnessModal && (
        <AddWitnessModal
          show={showAddWitnessModal}
          handleClose={handleClose}
          refetchWitnesses={fetchData}
          isDummy={isDummy}
          isEdit={!!editTarget}
          witness={editTarget || {}}
          deleteConfirmPopup={() => setShowDeleteConfirm(true)}
          retainedByList={retainedByList}
          statesAbrs={states}
        />
      )}
      {showDeleteConfirm && (
        <ConfirmDeletePopup
          entity="Delete Witness"
          handleClose={() => setShowDeleteConfirm(false)}
          handleDeleteSubmission={handleDeleteSubmission}
        />
      )}
    </>
  );
}

export default WitnessesPage;
